import axios, {AxiosError, AxiosResponse} from "axios";

export default class Form {

    /**
     * Create the form error helper instance.
     */
    public errors: object;
    public busy: Boolean;
    public successful: Boolean;
    public data: object;

    /**
     * Form constructor
     *
     * @param data
     * @param filter Allow filtering for specific keys i.e. id, name
     */
    constructor(data: object, filter: string[] = []) {

        let filtered = {}

        // Create properties user requested
        filter.forEach( (term) => {
            filtered[term]=null;
        });

        // Transfer data on the properties
        for (let key in data) {
            if (data.hasOwnProperty(key)) {
                if (filter.length===0 || filter.includes(key)) {
                    filtered[key] = data[key]!==null ? data[key] : null;
                }
            }
        }

        this.data = filtered;
        this.successful = false;
        this.busy = false;
        this.errors = {}
    };

    /**
     * Start processing the form.
     */

    private startProcessing() {
        this.errors = {};
        this.busy = true;
        this.successful = false;
    };

    /**
     * Finish processing the form.
     */

    private finishProcessing() {
        this.busy = false;
        this.successful = true;
    };

    /**
     * Reset the errors and other state for the form.
     */

    public reset() {
        this.errors = {};
        this.busy = false;
        this.successful = false;
    };

    /**
     * Clear for data
     */

    public clearData() {
        this.reset();
        this.data = {};
    }

    /**
     * Get errors for a specific field
     *
     * @param {string} key
     * @returns {any}
     */
    public getError(key: string) {
        if (this.errors[key]) {
            return this.errors[key];
        }
    }

    /**
     * Has error for a field
     *
     * @param {string} key
     */
    public hasError(key: string) {
        return this.errors[key] ? true : false
    }

    public getAllErrors() {
        return this.errors;
    }

    /**
     * Check if form contains errors
     *
     * @returns {boolean}
     */
    public hasErrors() {
        return Object.keys(this.errors).length > 0;
    }

    /**
     * Set the errors on the form.
     */

    private setErrors(errors: object) {
        this.busy = false;
        this.errors= errors;
    };

    /**
     * Send form to the server
     *
     * @param {string} method
     * @param {string} uri
     * @returns {Promise<any>}
     */

    public send(method: string, uri:string) {

        if (typeof axios[method] !=="function") {
            throw Error("Invalid method: "+method);
        }

        return new Promise((resolve, reject) => {
            this.startProcessing();

            axios[method](uri, JSON.parse(JSON.stringify(this.data)))
                .then( (response: AxiosResponse) => {
                    this.finishProcessing();
                    resolve(response);
                })
                .catch( (error: AxiosError) => {

                    if (error.response) {
                        this.setErrors(error.response.data.errors);
                        reject(error.response);
                    }
                    reject(error);
                });
        });
    }
};
